var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 12.25q0 1.1595-.105 2.25H8.73a34 34 0 0 1-.14-2.25c.023-.773.07-1.523.14-2.25h6.54q.105 1.0905.105 2.25M20.719 10c.187.727.281 1.477.281 2.25s-.094 1.523-.281 2.25h-4.325a24.1 24.1 0 0 0 0-4.5zm-.387-1.125h-4.078c-.375-2.297-1.031-4.078-1.969-5.344 1.406.399 2.637 1.055 3.692 1.969a9.25 9.25 0 0 1 2.355 3.375m-5.238 0H8.906c.211-1.29.528-2.402.95-3.34.374-.82.761-1.418 1.16-1.793q.597-.5265.984-.492c.258-.023.586.14.984.492.399.375.786.973 1.16 1.793.422.938.739 2.05.95 3.34m-11.426 0A9.25 9.25 0 0 1 6.023 5.5c1.055-.914 2.286-1.57 3.692-1.969-.938 1.266-1.594 3.047-1.969 5.344zM7.605 10a34 34 0 0 0-.14 2.25c.023.75.07 1.5.14 2.25H3.281A8.97 8.97 0 0 1 3 12.25c0-.773.094-1.523.281-2.25zm2.25 8.965c-.421-.938-.738-2.05-.949-3.34h6.188c-.211 1.29-.528 2.402-.95 3.34-.374.82-.761 1.418-1.16 1.793q-.597.5265-1.02.492c-.234.023-.55-.14-.948-.492-.399-.375-.786-.973-1.16-1.793Zm-.14 2.004C8.309 20.57 7.078 19.914 6.023 19a9.25 9.25 0 0 1-2.355-3.375h4.078c.375 2.297 1.031 4.078 1.969 5.344m4.57 0c.938-1.266 1.594-3.047 1.969-5.344h4.078A9.25 9.25 0 0 1 17.977 19c-1.055.914-2.286 1.57-3.692 1.969"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/globus-icon.33963cc0f21eb0f72c29ff9b2a1f8165.svg";